/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { useEffect } from 'react';


export default function SizeSelector({ size, onChange, producto, color }) {
  const [isOpen, setIsOpen] = useState(false);
  const [sizes, setSizes] = useState([])
   
  
  useEffect(() => {
    console.log(producto.inventarios)    
    const tallasFilters = producto.inventarios
    .filter(objeto => objeto.color === color.dataC) // Filtra por color "Amarillo"
    .map(objeto => objeto.talla)
    setSizes(tallasFilters);
    console.log(color)
    console.log(tallasFilters)

    onChange(tallasFilters[0], "size")
   }, [color])
  
  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '300px',
    position: 'relative',
    fontFamily: 'Arial, sans-serif',
  };

  const labelStyle = {
    marginBottom: '8px',
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#fff',
  };

  const selectStyle = {
    color: '#000',
    padding: '10px',
    fontSize: '14px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    backgroundColor: '#fff',
    cursor: 'pointer',
    appearance: 'none',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
  };


  const optionStyle = {
    padding: '8px',
    fontSize: '14px',
    backgroundColor: '#fff',
    color: '#333',
    cursor: 'pointer',
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <label htmlFor="size-select" style={labelStyle}>
        Tamaño del marco:
      </label>
      <div style={containerStyle}>

        <div style={{ position: 'relative' }}>
          <select
            id="size-select"
            value={size}
            onChange={(e) => onChange(e, "size")}
            onFocus={() => setIsOpen(true)}
            onBlur={() => setIsOpen(false)}
            style={selectStyle}
          >
            {sizes.map((sizeOption) => (
              <option key={sizeOption} value={sizeOption} style={optionStyle}>
                {sizeOption}
              </option>
            ))}
          </select>

        </div>
      </div>
    </div>
  );
}

